export const params = {
  restEndpoints: {
    lead: 'v4/onboarding/customer/',
    user: 'v3/secureonboarding/user/{customerid}/name/',
    phone: 'v3/secureonboarding/user/{customerid}/phone/',
    ssn: 'v1/secureonboarding/user/',
    address: 'v2/secureonboarding/user/',
    referralOwner: 'v2/public/firstName/',
    login: 'v2/onboarding/user/',
    getIndustry: 'v3/secureonboarding/user/{customerid}/industryList',
  },
  httpHeaders: {
    recaptcha: 'recaptcha',
    auth: 'Authorization',
  },
  responseCodeEnums: {
    INVALID_PHONE_NUMBER: '4010',
    USER_INCORRECT_STATE: '4012',
    REFERRAL_CODE_EXPIRE: '4013',
    INVALID_REFERRAL_CODE: '4015',
    FAILED_KYC: '4017',
    TC_NOT_ACCEPTED: '4018',
    EMAIL_ALREADY_EXISTS: '4041',
    INVALID_SSN_FORMAT: '4023',
    INVALID_EMAIL_FORMAT: '4024',
    USER_LOCKED: '4026',
    MUST_BE_OLDER_THAN: '4028',
    NAME_TOO_LONG: '4094',
    CUSTOMER_ALREADY_REGISTER: '4035',
    FAILED_KYC_CHECKING: '4307',
    FAILED_KYC_MORE_INFO: '4308',
    FAILED_KYC_MORE_INFO_AUTO: '4309',
    INVALID_CITY: '4043',
    INVALID_STATE: '4045',
    INVALID_POSTAL: '4046',
    INVALID_FIRST_NAME: '4047',
    INVALID_LAST_NAME: '4048',
    SSN_ALREADY_EXISTS: '4051',
    INVALID_LINE1: '4052',
    INVALID_LINE2: '4076',
    CAPTCHA_FAILED: '4056',
    CUSTOMER_LEAD_NOT_FOUND: '4057',
    INCORRECT_AGE: '4078',
    PHONE_NUMBER_VOIP: '4302',
    PHONE_NUMBER_LANDLINE: '4304',
    FAILED_KYC_RESUBMIT: '4317',
    FAILED_KYC_PARTNER: '4318',
    FAILED_KYC_RESUBMIT_ADDRESS: '43171',
    FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX: '43172',
    FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL: '43173',
    FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE: '43174',
    FAILED_KYC_RESUBMIT_ADDRESS_PARTNER: '43175',
    NEW_PHONE_EXISTS: '4350',
    PLEASE_WAIT: '5100',
    INVALID_PASSWORD_FORMAT: '40015',
    PASSWORD_TOO_SHORT: '40018',
    PASSWORD_TOO_LONG: '40019',
    PASSWORD_ILLEGAL_REPEAT: '40024',
    PASSWORD_ILLEGAL_NUMERIC: '40027',
    PASSWORD_ILLEGAL_ALPHABETICAL: '40028',
    PASSWORD_ILLEGAL_SEQUENCE: '40029',
    ACCOUNT_NOT_EXISTS: '4003',
    MFA_CODE_IS_INVALID: '40032',
    INCORRECT_USER_PASSWORD: '40033',
    INCORRECT_USER_PASSWORD_FOR_BROWSER: '40049',
    ID_ALREADY_EXISTS: '40511',
    CANT_UPDATE_UBO: '40065',
    EMAIL_CHANGE_IS_NOT_ALLOWED: '41195',
    UBO_EMAIL_ALREADY_EXISTS: '41196',
    INVALID_LINE1_PO_BOX: '41197',
    UBO_SSN_ALREADY_EXISTS: '41198',
    BUSINESS_ADDRESS_AGENT: '61001',
    NON_US_BUSINESS_ADDRESS_AGENT: '61002',
    PHONE_NUMBER_NOT_US: '43021',
    BUSINESS_NAME_ILLEGAL_NAME: '80003',
    LLC_INVALID_EIN: '80004',
    LLC_INVALID_STATE: '80005',
    EIN_IS_NOT_SSN: '80010',
    EIN_ALREADY_EXISTS: '80012',
    EIN_NOT_UNIQUE: '80013',
    OWNERSHIP_PERCENT_NOT_VALID: '90223',
    EXPIRATION_MUST_BE_FUTURE: '4031',
    tokenExpired: '401',
    FILE_TOO_LARGE: '413',
    INVALID_LOGIN_COUNTRY: '40111',
  },
  states: [
    {
      id: 'AK',
      title: 'AK',
    },
    {
      id: 'AL',
      title: 'AL',
    },
    {
      id: 'AR',
      title: 'AR',
    },
    {
      id: 'AZ',
      title: 'AZ',
    },
    {
      id: 'CA',
      title: 'CA',
    },
    {
      id: 'CO',
      title: 'CO',
    },
    {
      id: 'CT',
      title: 'CT',
    },
    {
      id: 'DC',
      title: 'DC',
    },
    {
      id: 'DE',
      title: 'DE',
    },
    {
      id: 'FL',
      title: 'FL',
    },
    {
      id: 'GA',
      title: 'GA',
    },
    {
      id: 'HI',
      title: 'HI',
    },
    {
      id: 'IA',
      title: 'IA',
    },
    {
      id: 'ID',
      title: 'ID',
    },
    {
      id: 'IL',
      title: 'IL',
    },
    {
      id: 'IN',
      title: 'IN',
    },
    {
      id: 'KS',
      title: 'KS',
    },
    {
      id: 'KY',
      title: 'KY',
    },
    {
      id: 'LA',
      title: 'LA',
    },
    {
      id: 'MA',
      title: 'MA',
    },
    {
      id: 'MD',
      title: 'MD',
    },
    {
      id: 'ME',
      title: 'ME',
    },
    {
      id: 'MI',
      title: 'MI',
    },
    {
      id: 'MN',
      title: 'MN',
    },
    {
      id: 'MO',
      title: 'MO',
    },
    {
      id: 'MS',
      title: 'MS',
    },
    {
      id: 'MT',
      title: 'MT',
    },
    {
      id: 'NC',
      title: 'NC',
    },
    {
      id: 'NE',
      title: 'NE',
    },
    {
      id: 'NH',
      title: 'NH',
    },
    {
      id: 'NJ',
      title: 'NJ',
    },
    {
      id: 'NM',
      title: 'NM',
    },
    {
      id: 'NV',
      title: 'NV',
    },
    {
      id: 'NY',
      title: 'NY',
    },
    {
      id: 'ND',
      title: 'ND',
    },
    {
      id: 'OH',
      title: 'OH',
    },
    {
      id: 'OK',
      title: 'OK',
    },
    {
      id: 'OR',
      title: 'OR',
    },
    {
      id: 'PA',
      title: 'PA',
    },
    {
      id: 'RI',
      title: 'RI',
    },
    {
      id: 'SC',
      title: 'SC',
    },
    {
      id: 'SD',
      title: 'SD',
    },
    {
      id: 'TN',
      title: 'TN',
    },
    {
      id: 'TX',
      title: 'TX',
    },
    {
      id: 'UT',
      title: 'UT',
    },
    {
      id: 'VT',
      title: 'VT',
    },
    {
      id: 'VA',
      title: 'VA',
    },
    {
      id: 'WA',
      title: 'WA',
    },
    {
      id: 'WI',
      title: 'WI',
    },
    {
      id: 'WV',
      title: 'WV',
    },
    {
      id: 'WY',
      title: 'WY',
    },
  ],
  businessTypes: [
    { id: 'Accounting', title: 'Accounting' },
    { id: 'Art', title: 'Art' },
    { id: 'Beauty', title: 'Beauty' },
    { id: 'Business Consultant', title: 'Business Consultant' },
    { id: 'Caregiving', title: 'Caregiving' },
    { id: 'Cleaning/Housekeeping', title: 'Cleaning/Housekeeping' },
    { id: 'Construction', title: 'Construction' },
    { id: 'Cooking/Food', title: 'Cooking/Food' },
    { id: 'Design', title: 'Design' },
    {
      id: 'Digital Marketing/Social Media',
      title: 'Digital Marketing/Social Media',
    },
    { id: 'Driving/Delivery', title: 'Driving/Delivery' },
    { id: 'Education', title: 'Education' },
    { id: 'Entertainment', title: 'Entertainment' },
    { id: 'Health/Therapy', title: 'Health/Therapy' },
    { id: 'Human Resources', title: 'Human Resources' },
    { id: 'Insurance/Benefits Agent', title: 'Insurance/Benefits Agent' },
    { id: 'Legal', title: 'Legal' },
    { id: 'Maintenance/Repair', title: 'Maintenance/Repair' },
    { id: 'Modeling', title: 'Modeling' },
    { id: 'Photography/Videography', title: 'Photography/Videography' },
    { id: 'Programming/IT', title: 'Programming/IT' },
    { id: 'Real Estate', title: 'Real Estate' },
    { id: 'Retail / E-Commerce', title: 'Retail / E-Commerce' },
    { id: 'Sales', title: 'Sales' },
    { id: 'Security', title: 'Security' },
    { id: 'Sports/Fitness', title: 'Sports/Fitness' },
    { id: 'Translation/Writing', title: 'Translation/Writing' },
  ],
  mainSourceOfIncome: [
    { id: 'LLC', title: 'Single Member LLC (Full-time)' },
    {
      id: 'DBA',
      title: 'Sole Proprietor with DBA (Full-time)',
    },
    { id: 'SSN', title: 'Sole Proprietor (Full-time)' },

    { id: 'Part_Time', title: 'Freelance on the side' },
    {
      id: 'Governmental_Benefits',
      title: 'Government Benefits',
    },
  ],
  paramsCookiesLookup: [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_partner',
    'utm_term',
    'af_c_id',
    'af_adset_id',
    'af_ad_id',
    'af_adset',
    'af_keyword_id',
    'ttclid',
    'CID',
    'gclid',
    '_ga_VYHG5X0XGR',
  ],
  nationality: [
    { text: 'Afghanistan', value: 'AF' },
    { text: 'Aland Islands', value: 'AX' },
    { text: 'Albania', value: 'AL' },
    { text: 'Algeria', value: 'DZ' },
    { text: 'American Samoa', value: 'AS' },
    { text: 'Andorra', value: 'AD' },
    { text: 'Angola', value: 'AO' },
    { text: 'Anguilla', value: 'AI' },
    { text: 'Antarctica', value: 'AQ' },
    { text: 'Antigua and Barbuda', value: 'AG' },
    { text: 'Argentina', value: 'AR' },
    { text: 'Armenia', value: 'AM' },
    { text: 'Aruba', value: 'AW' },
    { text: 'Australia', value: 'AU' },
    { text: 'Austria', value: 'AT' },
    { text: 'Azerbaijan', value: 'AZ' },
    { text: 'Bahamas', value: 'BS' },
    { text: 'Bahrain', value: 'BH' },
    { text: 'Bangladesh', value: 'BD' },
    { text: 'Barbados', value: 'BB' },
    { text: 'Belarus', value: 'BY' },
    { text: 'Belgium', value: 'BE' },
    { text: 'Belize', value: 'BZ' },
    { text: 'Benin', value: 'BJ' },
    { text: 'Bermuda', value: 'BM' },
    { text: 'Bhutan', value: 'BT' },
    { text: 'Bolivia', value: 'BO' },
    { text: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
    { text: 'Bosnia and Herzegovina', value: 'BA' },
    { text: 'Botswana', value: 'BW' },
    { text: 'Bouvet Island', value: 'BV' },
    { text: 'Brazil', value: 'BR' },
    { text: 'British Indian Ocean Territory', value: 'IO' },
    { text: 'Brunei Darussalam', value: 'BN' },
    { text: 'Bulgaria', value: 'BG' },
    { text: 'Burkina Faso', value: 'BF' },
    { text: 'Burundi', value: 'BI' },
    { text: 'Cambodia', value: 'KH' },
    { text: 'Cameroon', value: 'CM' },
    { text: 'Canada', value: 'CA' },
    { text: 'Cape Verde', value: 'CV' },
    { text: 'Cayman Islands', value: 'KY' },
    { text: 'Central African Republic', value: 'CF' },
    { text: 'Chad', value: 'TD' },
    { text: 'Chile', value: 'CL' },
    { text: 'China', value: 'CN' },
    { text: 'Christmas Island', value: 'CX' },
    { text: 'Cocos (Keeling) Islands', value: 'CC' },
    { text: 'Colombia', value: 'CO' },
    { text: 'Comoros', value: 'KM' },
    { text: 'Congo', value: 'CG' },
    { text: 'Congo, Democratic Republic of the Congo', value: 'CD' },
    { text: 'Cook Islands', value: 'CK' },
    { text: 'Costa Rica', value: 'CR' },
    { text: "Cote D'Ivoire", value: 'CI' },
    { text: 'Croatia', value: 'HR' },
    { text: 'Cuba', value: 'CU' },
    { text: 'Curacao', value: 'CW' },
    { text: 'Cyprus', value: 'CY' },
    { text: 'Czech Republic', value: 'CZ' },
    { text: 'Denmark', value: 'DK' },
    { text: 'Djibouti', value: 'DJ' },
    { text: 'Dominica', value: 'DM' },
    { text: 'Dominican Republic', value: 'DO' },
    { text: 'Ecuador', value: 'EC' },
    { text: 'Egypt', value: 'EG' },
    { text: 'El Salvador', value: 'SV' },
    { text: 'Equatorial Guinea', value: 'GQ' },
    { text: 'Eritrea', value: 'ER' },
    { text: 'Estonia', value: 'EE' },
    { text: 'Ethiopia', value: 'ET' },
    { text: 'Falkland Islands (Malvinas)', value: 'FK' },
    { text: 'Faroe Islands', value: 'FO' },
    { text: 'Fiji', value: 'FJ' },
    { text: 'Finland', value: 'FI' },
    { text: 'France', value: 'FR' },
    { text: 'French Guiana', value: 'GF' },
    { text: 'French Polynesia', value: 'PF' },
    { text: 'French Southern Territories', value: 'TF' },
    { text: 'Gabon', value: 'GA' },
    { text: 'Gambia', value: 'GM' },
    { text: 'Georgia', value: 'GE' },
    { text: 'Germany', value: 'DE' },
    { text: 'Ghana', value: 'GH' },
    { text: 'Gibraltar', value: 'GI' },
    { text: 'Greece', value: 'GR' },
    { text: 'Greenland', value: 'GL' },
    { text: 'Grenada', value: 'GD' },
    { text: 'Guadeloupe', value: 'GP' },
    { text: 'Guam', value: 'GU' },
    { text: 'Guatemala', value: 'GT' },
    { text: 'Guernsey', value: 'GG' },
    { text: 'Guinea', value: 'GN' },
    { text: 'Guinea-Bissau', value: 'GW' },
    { text: 'Guyana', value: 'GY' },
    { text: 'Haiti', value: 'HT' },
    { text: 'Heard Island and Mcdonald Islands', value: 'HM' },
    { text: 'Holy See (Vatican City State)', value: 'VA' },
    { text: 'Honduras', value: 'HN' },
    { text: 'Hong Kong', value: 'HK' },
    { text: 'Hungary', value: 'HU' },
    { text: 'Iceland', value: 'IS' },
    { text: 'India', value: 'IN' },
    { text: 'Indonesia', value: 'ID' },
    { text: 'Iran, Islamic Republic of', value: 'IR' },
    { text: 'Iraq', value: 'IQ' },
    { text: 'Ireland', value: 'IE' },
    { text: 'Isle of Man', value: 'IM' },
    { text: 'Israel', value: 'IL' },
    { text: 'Italy', value: 'IT' },
    { text: 'Jamaica', value: 'JM' },
    { text: 'Japan', value: 'JP' },
    { text: 'Jersey', value: 'JE' },
    { text: 'Jordan', value: 'JO' },
    { text: 'Kazakhstan', value: 'KZ' },
    { text: 'Kenya', value: 'KE' },
    { text: 'Kiribati', value: 'KI' },
    { text: "Korea, Democratic People's Republic of", value: 'KP' },
    { text: 'Korea, Republic of', value: 'KR' },
    { text: 'Kosovo', value: 'XK' },
    { text: 'Kuwait', value: 'KW' },
    { text: 'Kyrgyzstan', value: 'KG' },
    { text: "Lao People's Democratic Republic", value: 'LA' },
    { text: 'Latvia', value: 'LV' },
    { text: 'Lebanon', value: 'LB' },
    { text: 'Lesotho', value: 'LS' },
    { text: 'Liberia', value: 'LR' },
    { text: 'Libyan Arab Jamahiriya', value: 'LY' },
    { text: 'Liechtenstein', value: 'LI' },
    { text: 'Lithuania', value: 'LT' },
    { text: 'Luxembourg', value: 'LU' },
    { text: 'Macao', value: 'MO' },
    { text: 'Macedonia, the Former Yugoslav Republic of', value: 'MK' },
    { text: 'Madagascar', value: 'MG' },
    { text: 'Malawi', value: 'MW' },
    { text: 'Malaysia', value: 'MY' },
    { text: 'Maldives', value: 'MV' },
    { text: 'Mali', value: 'ML' },
    { text: 'Malta', value: 'MT' },
    { text: 'Marshall Islands', value: 'MH' },
    { text: 'Martinique', value: 'MQ' },
    { text: 'Mauritania', value: 'MR' },
    { text: 'Mauritius', value: 'MU' },
    { text: 'Mayotte', value: 'YT' },
    { text: 'Mexico', value: 'MX' },
    { text: 'Micronesia, Federated States of', value: 'FM' },
    { text: 'Moldova, Republic of', value: 'MD' },
    { text: 'Monaco', value: 'MC' },
    { text: 'Mongolia', value: 'MN' },
    { text: 'Montenegro', value: 'ME' },
    { text: 'Montserrat', value: 'MS' },
    { text: 'Morocco', value: 'MA' },
    { text: 'Mozambique', value: 'MZ' },
    { text: 'Myanmar', value: 'MM' },
    { text: 'Namibia', value: 'NA' },
    { text: 'Nauru', value: 'NR' },
    { text: 'Nepal', value: 'NP' },
    { text: 'Netherlands', value: 'NL' },
    { text: 'Netherlands Antilles', value: 'AN' },
    { text: 'New Caledonia', value: 'NC' },
    { text: 'New Zealand', value: 'NZ' },
    { text: 'Nicaragua', value: 'NI' },
    { text: 'Niger', value: 'NE' },
    { text: 'Nigeria', value: 'NG' },
    { text: 'Niue', value: 'NU' },
    { text: 'Norfolk Island', value: 'NF' },
    { text: 'Northern Mariana Islands', value: 'MP' },
    { text: 'Norway', value: 'NO' },
    { text: 'Oman', value: 'OM' },
    { text: 'Pakistan', value: 'PK' },
    { text: 'Palau', value: 'PW' },
    { text: 'Palestinian Territory, Occupied', value: 'PS' },
    { text: 'Panama', value: 'PA' },
    { text: 'Papua New Guinea', value: 'PG' },
    { text: 'Paraguay', value: 'PY' },
    { text: 'Peru', value: 'PE' },
    { text: 'Philippines', value: 'PH' },
    { text: 'Pitcairn', value: 'PN' },
    { text: 'Poland', value: 'PL' },
    { text: 'Portugal', value: 'PT' },
    { text: 'Puerto Rico', value: 'PR' },
    { text: 'Qatar', value: 'QA' },
    { text: 'Reunion', value: 'RE' },
    { text: 'Romania', value: 'RO' },
    { text: 'Russian Federation', value: 'RU' },
    { text: 'Rwanda', value: 'RW' },
    { text: 'Saint Barthelemy', value: 'BL' },
    { text: 'Saint Helena', value: 'SH' },
    { text: 'Saint Kitts and Nevis', value: 'KN' },
    { text: 'Saint Lucia', value: 'LC' },
    { text: 'Saint Martin', value: 'MF' },
    { text: 'Saint Pierre and Miquelon', value: 'PM' },
    { text: 'Saint Vincent and the Grenadines', value: 'VC' },
    { text: 'Samoa', value: 'WS' },
    { text: 'San Marino', value: 'SM' },
    { text: 'Sao Tome and Principe', value: 'ST' },
    { text: 'Saudi Arabia', value: 'SA' },
    { text: 'Senegal', value: 'SN' },
    { text: 'Serbia', value: 'RS' },
    { text: 'Serbia and Montenegro', value: 'CS' },
    { text: 'Seychelles', value: 'SC' },
    { text: 'Sierra Leone', value: 'SL' },
    { text: 'Singapore', value: 'SG' },
    { text: 'Sint Maarten', value: 'SX' },
    { text: 'Slovakia', value: 'SK' },
    { text: 'Slovenia', value: 'SI' },
    { text: 'Solomon Islands', value: 'SB' },
    { text: 'Somalia', value: 'SO' },
    { text: 'South Africa', value: 'ZA' },
    { text: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { text: 'South Sudan', value: 'SS' },
    { text: 'Spain', value: 'ES' },
    { text: 'Sri Lanka', value: 'LK' },
    { text: 'Sudan', value: 'SD' },
    { text: 'Suriname', value: 'SR' },
    { text: 'Svalbard and Jan Mayen', value: 'SJ' },
    { text: 'Swaziland', value: 'SZ' },
    { text: 'Sweden', value: 'SE' },
    { text: 'Switzerland', value: 'CH' },
    { text: 'Syrian Arab Republic', value: 'SY' },
    { text: 'Taiwan, Province of China', value: 'TW' },
    { text: 'Tajikistan', value: 'TJ' },
    { text: 'Tanzania, United Republic of', value: 'TZ' },
    { text: 'Thailand', value: 'TH' },
    { text: 'Timor-Leste', value: 'TL' },
    { text: 'Togo', value: 'TG' },
    { text: 'Tokelau', value: 'TK' },
    { text: 'Tonga', value: 'TO' },
    { text: 'Trinidad and Tobago', value: 'TT' },
    { text: 'Tunisia', value: 'TN' },
    { text: 'Turkey', value: 'TR' },
    { text: 'Turkmenistan', value: 'TM' },
    { text: 'Turks and Caicos Islands', value: 'TC' },
    { text: 'Tuvalu', value: 'TV' },
    { text: 'Uganda', value: 'UG' },
    { text: 'Ukraine', value: 'UA' },
    { text: 'United Arab Emirates', value: 'AE' },
    { text: 'United Kingdom', value: 'GB' },
    { text: 'United States', value: 'US' },
    { text: 'United States Minor Outlying Islands', value: 'UM' },
    { text: 'Uruguay', value: 'UY' },
    { text: 'Uzbekistan', value: 'UZ' },
    { text: 'Vanuatu', value: 'VU' },
    { text: 'Venezuela', value: 'VE' },
    { text: 'Viet Nam', value: 'VN' },
    { text: 'Virgin Islands, British', value: 'VG' },
    { text: 'Virgin Islands, U.s.', value: 'VI' },
    { text: 'Wallis and Futuna', value: 'WF' },
    { text: 'Western Sahara', value: 'EH' },
    { text: 'Yemen', value: 'YE' },
    { text: 'Zambia', value: 'ZM' },
    { text: 'Zimbabwe', value: 'ZW' },
  ],
  stepVersion: 'v2',
}



// WEBPACK FOOTER //
// ./src/localData/index.js